export default "<div #routemap class=\"map\">\n</div>";